var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loading-overlay"},[_c('div',{staticClass:"loader is-large"}),_vm._v(" "),_c('p',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }